import { DateTime } from 'luxon';
import { PAGE_SIZE } from 'services/constants/env';
import { ESortDirection } from 'ui/EasTable/types';
import { TEmCommentItem, TEmCommentsRequest } from 'redux/reducers/emManagement/types';

export const formatScheduledActionOnUtc = (value: unknown): string | null => {
	if (!value || String(value).trim() === '') return null;

	const dateOnly = String(value).slice(0, 10);
	const [year, month, day] = dateOnly.split('-').map(Number);

	return DateTime.utc(year, month, day).toISO({ suppressMilliseconds: false });
};

export const formatScheduledActionOnForDisplay = (value: unknown): string => {
	if (!value || String(value).trim() === '') return '';

	return String(value).slice(0, 10);
};

// scheduledActionOn is stored as a UTC date-only value, so it is compared with the current UTC day
export const isPastNotification = (value: unknown): boolean => {
	const scheduledDate = formatScheduledActionOnForDisplay(value);

	if (!scheduledDate) return false;

	return scheduledDate < DateTime.utc().toFormat('yyyy-MM-dd');
};

export const filterOutPastNotifications = (items: TEmCommentItem[]): TEmCommentItem[] =>
	items.filter((item: TEmCommentItem) => !isPastNotification(item?.scheduledActionOn));

export const getCommentsListRequest = (emId: string): TEmCommentsRequest => ({
	pageNumber: 1,
	pageSize: PAGE_SIZE,
	orderBy: [{ fieldName: 'id', direction: ESortDirection.DESC }],
	filters: [{ fieldName: 'emId', value: emId, operator: '=' }],
});

export const getNotificationsListRequest = (emId: string): TEmCommentsRequest => ({
	pageNumber: 1,
	pageSize: PAGE_SIZE,
	orderBy: [{ fieldName: 'scheduledActionOn', direction: ESortDirection.DESC }],
	filters: [
		{ fieldName: 'emId', value: emId, operator: '=' },
		{ fieldName: 'scheduledActionOn', value: '0001-01-01T00:00:00', operator: '<>' },
		{ fieldName: 'scheduledActionOn', value: 'null', operator: '<>' },
	],
});
